<template>
  <div>

      <div class="dropdown flex w-64">

          <div class="flex-1 pr-1">
            <v-select
              :options="options"
              label="name"
              placeholder="Add Member to Group"
              v-model="selected"
              >
              </v-select>
          </div>
          <div>
              <button v-if="selected" v-on:click="addMember" type="submit" class="commitbutton text-xs p-1 pb-0 transition"><i aria-hidden="true" class="material-icons text-xl">check</i></button>
          </div>

      </div>

  </div>
</template>

<script>
    import VueSelect from 'vue-select';
    import axios from 'axios'

    export default {

        components: { VueSelect },

        props: {
            options: '',
            placeholder: {
                default: 'Add Member to Group'
            },
            route:''
        },

        data() {
          return {
            success: false,
            loaded: true,
            groupId: '',
            name: '',
            selected: '',
          }
        },

        methods: {

          addMember: function (event) {
            if (this.loaded) {
              this.loaded = false;
              this.success = false;
              $( ".commitbutton").addClass( "loading" );
              axios.post(
                  this.route.replace("selected.id", this.selected.id),
                {
                    // userId: this.selected.id
                 }
              ).then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  location.reload();
                })
            };
          }

        },

    }
</script>
